/**
 * Buckets hidden from the optimizer UI.
 *
 * MBE has no PreRoute staging workflow, so this branch hides the PreRoute
 * column/card everywhere it would render (board, map, publish modal, optimize
 * dialog stat). This is DISPLAY ONLY — PreRoute stays in the data pipeline
 * (buildOptimizePayload still locks it, publishRoutesSelective still reads it),
 * so nothing about optimize or publish behaviour changes. master/SECONDSHOP
 * keeps its own (showing) version.
 */
export const HIDDEN_UI_BUCKETS: readonly string[] = ['PreRoute']

export const isHiddenBucket = (vehicle: string): boolean =>
  HIDDEN_UI_BUCKETS.includes(vehicle)
